module.exports = __webpack_public_path__ + "static/cloakwood_hermit-7390cf677016ca7d5aab90baef5e9ec3.jpeg";